// extracted by css-extract-rspack-plugin
export default {"relevanceScoreButtonContainer":"oqAXX7KDzjQRrJXg__relevanceScoreButtonContainer___","newRelevanceScoreButton":"Ok3rN4HZUIwI86HK__newRelevanceScoreButton___"};